module.exports = __webpack_public_path__ + "static/media/code_input.4262e1f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code_input.svg
// module id = 130
// module chunks = 0